module.exports = __webpack_public_path__ + "assets/alpinejs.5afd5058.svg";